import { ILinkedObjectSpecifiable } from "./ILinkedObjectSpecifiable";
import { TableIndex } from "./TableIndex";

export class LinkedObject {
  constructor(
    public type: string,
    public id: number,
    public key: string,
    public subKey?: string,
    public tableIndex?: TableIndex,
    public isDate?: boolean,
  ) {
  }

  clone(): LinkedObject {
    return new LinkedObject(
      this.type,
      this.id,
      this.key,
      this.subKey,
      this.tableIndex.clone(),
      this.isDate);
  }

  static from(source: ILinkedObjectSpecifiable): LinkedObject {
    return new LinkedObject(
      source.type,
      source.id,
      source.key,
      source.subKey,
      TableIndex.from(source.tableIndex),
      source.isDate);
  }

  static to(source: LinkedObject): ILinkedObjectSpecifiable {
    return {
      type: source.type,
      id: source.id,
      key: source.key,
      subKey: source.subKey,
      tableIndex: TableIndex.to(source.tableIndex),
      isDate: source.isDate,
    };
  }
}
